import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '& .label' : {
      color: '#69738c',
      fontWeight: 'bold'
    },
    '& .bottom-properties': {
      display: 'flex',
      justifyContent: 'flex-end',
      '& > .choice-value-container': {
        display: 'flex',
        paddingTop: 12,
        '& > span': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        },
        '& > .choice-label': {
          fontWeight: 'bold'
        },
        '& > .choice-value': {
          marginLeft: 5
        }
      }
    }
  },
  premise: {
    "& > .label": {
      marginBottom: 20
    }
  },
  answer: {
    marginTop: 25,
    flexGrow: 1,
    color: '#828dab',
    "& .choice": {
      display: 'flex',
      marginTop: 20, 
      padding: '20px 15px',
      flexGrow: 1,
      borderRadius: 4,
      background: '#edf6fd',
      flexDirection: 'column',
      "& .header" : {
        marginBottom: 5,
        display: 'flex',
        "& .sorter": {
          fontSize: '14pt',
          cursor: 'pointer'
        },
        '& .index' : {
          marginLeft: 15,
          color: '#69738c',
          fontWeight: 'bold'
        },
        "& .filler": {
          flexGrow: 1
        },
        "& .delete": {
          fontSize: '14pt',
          cursor: 'pointer',
          color: '#ff3a3a',
          '&:hover': {
            transform: 'scale(1.1)'
          }
        }
      },
      "& .label" : {
        margin: '20px 5px 8px 0',
      },
      "& .correct": {
        marginTop: 9 
      }
    }
  }
}))

export {useStyles as default}
